$(document).ready(function () {

    var scenario = window.scenarios["3bm4s"];

    $(".showroom-widget-inner a").on("click", function () {

        $(".login-form-slide-box").removeClass("slide-register");
        $(".popup-action-title").removeClass("active-tab");
        $(".register-title").addClass("active-tab");

        Vivense.loginPopup.openFavoritesPopup(scenario.widget, scenario.name);

        // Close widget, do not show again
        $('.showroom-widget-inner .close-widget').trigger('click');
    });

    $(".showroom-widget-inner .close-widget").on("click", function () {
        Vivense.cookie.set(scenario.name + '_Closed','1',7 * 24);
        $(".showroom-widget-wrapper").remove();
    });
});